import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 21 21",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="M8.572 12.834c.686 1.116 2.136 1.888 3.819 1.888.313 0 .617-.028.91-.079l2.272 1.19V13.59c.658-.587 1.06-1.356 1.06-2.2 0-.862-.42-1.645-1.103-2.237" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /> <path clip-rule="evenodd" d="M10.27 4.167c-2.93 0-5.304 1.99-5.304 4.444 0 .998.398 1.917 1.061 2.658v2.898l2.563-1.343a6.227 6.227 0 0 0 1.68.232c2.928 0 5.303-1.99 5.303-4.445 0-2.454-2.375-4.444-5.303-4.444Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />' }
  })
);